module.exports = __webpack_public_path__ + "img/0-2.fd9416ce.png";